import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageInterceptor implements HttpInterceptor {
  constructor(private readonly translateService: TranslateService) {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.translateService && this.translateService.currentLang) {
      request = request.clone({
        setHeaders: {
          'Accept-Language': this.translateService.currentLang,
        },
      });
    }

    return next.handle(request);
  }
}
